<template>
  <div
    class="file-infoWrapper textStyleFile"
    :class="focus ? 'file-focusBorder' : ''"
    @click="
      status != 'data_preparing' && status != 'data_failed'
        ? showFileInfo(fileId, index, total)
        : null
    "
  >
    <div class="file-nameWrapper">
      <div style="height: 16px; margin-right: 5px"><FileSimpleIcon /></div>
      <div class="file-nameStyle">{{ name }}</div>
      <div
        class="file-tooltip"
        v-if="status != 'data_preparing' && status != 'data_failed'"
      >
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <div style="width: 19px; height: 19px" v-on="on" v-bind="attrs">
              <InfoIcon />
            </div>
          </template>
          <div>
            Төлөв:
            {{ total_synthesized + "/" + total }}
          </div>
          <div>Нийт хугацаа: {{ total }} сек</div>
          <div>Үүсгэсэн огноо: {{ getFormatDate }}</div>
        </v-tooltip>
      </div>
    </div>
    <div
      v-if="status != 'data_preparing' && status != 'data_failed'"
      class="file-infoMoreWrapper"
    >
      <div class="file-status">
        {{ total_synthesized + " / " + total }}
      </div>
      <div class="file-totalTime">{{ total }}</div>
      <div class="file-lastEdited">{{ getFormatDate }}</div>
      <v-spacer></v-spacer>
      <div class="file-otherThingsWrapper">
        <v-btn
          class="showBtn"
          @click="showFileInfo(fileId, index, total)"
          :disabled="focus == true"
          >нээх</v-btn
        >
        <v-menu bottom left min-width="140px" max-width="140px" offset-y>
          <template v-slot:activator="{ on }">
            <v-btn class="thingsBtn" v-on="on"><MenuIcon /></v-btn>
          </template>
          <v-list>
            <v-list-item-content class="align-center">
              <v-list-item
                class="file-listItem"
                @click="editAudioShowDialog(fileId, index, name)"
              >
                <EditIcon :width="18" :height="18" />
                <div class="editName">Нэр солих</div>
              </v-list-item>
              <v-list-item

                @click="deleteAudioShowDialog(fileId)"
              >
                <DeleteIcon :width="18" :height="18" color="#d23636" />
                <div class="deleteProject">Устгах</div>
              </v-list-item>
            </v-list-item-content>
          </v-list>
        </v-menu>
      </div>
    </div>
    <div v-else-if="status == 'data_preparing'">Файл бэлдэж байна...</div>
    <div v-else-if="status == 'data_failed'" class="file-failedWrapper">
      <div>Хөрвүүлэх боломжгүй файл</div>
      <v-menu bottom left min-width="140px" max-width="140px" offset-y>
        <template v-slot:activator="{ on }">
          <v-btn class="thingsBtn" v-on="on"><MenuIcon /></v-btn>
        </template>
        <v-list>
          <v-list-item-content class="align-center">
            <v-list-item @click="deleteAudioShowDialog(fileId)">
              <DeleteIcon :width="18" :height="18" color="#d23636" />
              <div class="deleteProject">Устгах</div>
            </v-list-item>
          </v-list-item-content>
        </v-list>
      </v-menu>
    </div>
  </div>
</template>
<script>
import { format } from "date-fns";
import MenuIcon from "../components/icons/MenuIcon";
import EditIcon from "../components/icons/EditIcon";
import DeleteIcon from "../components/icons/DeleteIcon";
import FileSimpleIcon from "../components/icons/FileSimpleIcon";
import InfoIcon from "../components/icons/InfoIcon";
export default {
  name: "FileInfo",
  components: { MenuIcon, DeleteIcon, EditIcon, FileSimpleIcon, InfoIcon },
  data: () => ({
    token: "",
    interval: null,
  }),
  props: {
    focus: Boolean,
    fileId: Number,
    index: Number,
    name: String,
    date: String,
    duration: Number,
    total_synthesized: Number,
    status: String,
    total: Number,
    deleteAudioShowDialog: { type: Function },
    editAudioShowDialog: { type: Function },
    showFileInfo: { type: Function },
    updateShowFocusedFile: { type: Function },
  },
  computed: {
    getFormatDate: function() {
      var currentDate = new Date(this.date);
      currentDate.setHours(currentDate.getHours());
      return format(currentDate, "yyyy/MM/dd HH:mm");
    },
  },
};
</script>

<style>
.file-infoWrapper {
  display: flex;
  width: 100%;
  height: 65px;
  align-items: center;
  transition: 0.2s ease-out;
  border-bottom: 1px solid #e8ebed;
  cursor: pointer;
}

.file-focusBorder {
  border: 1px solid #777ff6;
  border-radius: 6px;
}

.file-infoWrapper:hover {
  background-color: #f8f8f8;
  transition: 0.2s ease-out;
}

.textStyleFile {
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
  color: #000000;
  text-align: left;
}

.file-nameWrapper {
  display: flex;
  width: 25%;
  min-width: 200px;
  margin-right: 30px;
  padding-left: 10px;
  align-items: center;
}

.file-nameStyle {
  max-width: 121px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: 10px;
}

.file-tooltip {
  display: none !important;
}

.file-status {
  min-width: 66px;
  margin-right: 30px;
}

.file-totalTime {
  min-width: 88px;
  margin-right: 30px;
}

.file-lastEdited {
  min-width: 135px;
  margin-right: 30px;
}

.file-infoMoreWrapper {
  display: flex;
  width: calc(75% - 30px);
  height: 100%;
  align-items: center;
}

.file-otherThingsWrapper {
  width: auto;
  display: flex;
  justify-content: flex-end;
  padding-right: 10px;
}

.showBtn {
  background-color: #ffffff !important;
  text-transform: initial;
  color: #767676 !important;
  border: 2px solid #e5e5e5;
  border-radius: 6px;
  box-shadow: none;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  outline: none;
  margin-right: 5px;
  height: 34px !important;
  width: 64px !important;
}

.thingsBtn {
  background-color: #ffffff !important;
  text-transform: initial;
  color: #767676 !important;
  border-radius: 6px;
  box-shadow: none;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  outline: none;
  margin-right: 5px;
  height: 34px !important;
  min-width: 34px !important;
  padding: 0 !important;
}

.thingsBtn:hover {
  border: 2px solid #e5e5e5;
}
@media screen and (max-width: 900px) {
  .file-nameWrapper {
    width: 65%;
  }

  .file-otherThingsWrapper {
    width: 35%;
  }

  .file-tooltip {
    display: inline-block !important;
  }
  .file-lastEdited,
  .file-status,
  .file-totalTime {
    display: none;
  }
}

.file-failedWrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: calc(75% - 30px);
  flex-wrap: wrap;
  padding-right: 10px;
}

.v-menu__content {
  border: 1px solid #e5e5e5 !important;
  background-color: #ffffff;
  border-radius: 6px !important;
  box-shadow: none !important;
  padding-top: 0 !important;
  box-shadow: 0px 9px 16px rgba(0, 0, 0, 0.06) !important;
}

.v-list {
  padding: 0;
}

.v-list-item__content {
  padding: 0;
}

.file-listItem {
  border-bottom: 1px solid #e5e5e5;
}

.editName {
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
  color: #000000;
  margin-left: 10px;
}

.deleteProject {
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
  color: #d23636;
  margin-left: 10px;
}

.dialogWrapper {
  padding: 31px 38px;
}

@media screen and (max-width: 768px) {
  .file-infoWrapper {
    height: auto;
    padding: 4px;
  }
  .dialogWrapper {
    padding: 20px;
  }

  .file-nameWrapper {
    min-width: 120px;
  }

  .file-nameStyle {
    max-width: 96px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-right: 10px;
  }

  .file-failedWrapper {
    width: auto;
  }
}

.dialogTitleWrapper {
  display: flex;
  align-items: center;
  margin-bottom: 30px;
}

.dialogRemoveTitleWrapper {
  display: flex;
  align-items: center;
  margin-bottom: 25px;
}

.dialogRemoveQuestion {
  font-size: 14px;
  line-height: 16px;
  color: #767676;
}

.folderIconWrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
  min-height: 40px;
  background-color: #eff0fd;
  border-radius: 3px;
  margin-right: 10px;
}

.dialogTitle {
  font-size: 14px;
  font-weight: 500;
  color: #000000;
  margin-left: 10px;
}

.dialogRemoveTitle {
  font-size: 16px;
  font-weight: 500;
  color: #d23636;
  margin-left: 10px;
  line-height: 18px;
}

.dialogWarn {
  font-size: 14px;
  font-weight: 500;
  color: #767676;
  margin-bottom: 10px;
}

.createInputWrapper {
  display: flex;
  position: relative;
  height: 40px;
}
.createInputWrapper input[type="text"] {
  /* height: 40px; */
  padding-left: 15px;
  padding-right: 15px;
  font-size: 14px;
  font-weight: 400;
  border: 2px solid #e5e5e5;
  border-radius: 6px;
  float: left;
  width: 100%;
  background-color: #ffffff;
  line-height: 16px;
  transition: 0.4s ease-out;
}

.createInputWrapper input[type="text"]:focus {
  border: 2px solid #777ff6 !important;
  outline: none;
}

.createInputWrapper input[type="text"]:hover {
  border: 2px solid #777ff6 !important;
  transition: 0.4s ease-out;
  outline: none;
}

.dialogActionWrapper {
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
}

.closeBtn {
  background-color: #ffffff !important;
  text-transform: initial;
  color: #767676 !important;
  border: 2px solid #e5e5e5;
  border-radius: 6px;
  box-shadow: none;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  outline: none;
  margin-right: 15px;
  height: 34px !important;
  width: 64px !important;
}

.removeBtn {
  background-color: #d23636 !important;
  text-transform: initial;
  color: #ffffff !important;
  border-radius: 6px;
  box-shadow: none;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  outline: none;
  margin-right: 5px;
  height: 34px !important;
  width: 64px !important;
}

.createBtn {
  background-color: #777ff6 !important;
  text-transform: initial;
  color: #ffffff !important;
  border-radius: 6px;
  box-shadow: none;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  outline: none;
  margin-right: 5px;
  height: 34px !important;
  width: 64px !important;
}
</style>
